import fetchWithDefaults from '../CommonUtils/fetchWithDefaults';
import { httpBodyOptions } from '../CommonUtils/httpBodyOptions';

/* global ADV */

export const ERRORS_SET = 'EXECUTIVE_SUMMARY.ERRORS_SET';
export const EXECUTIVE_SUMMARY_MESSAGE_SET = 'EXECUTIVE_SUMMARY.EXECUTIVE_SUMMARY_MESSAGE_SET';
export const IS_SAVING_EXECUTIVE_SUMMARY_SET = 'EXECUTIVE_SUMMARY.IS_SAVING_EXECUTIVE_SUMMARY_SET';
export const IS_EDIT_EXECUTIVE_SUMMARY_MODAL_OPEN_SET =
  'EXECUTIVE_SUMMARY.IS_EDIT_EXECUTIVE_SUMMARY_MODAL_OPEN_SET';
export const IS_DELETING_EXECUTIVE_SUMMARY_SET =
  'EXECUTIVE_SUMMARY.IS_DELETING_EXECUTIVE_SUMMARY_SET';

export const setErrors = payload => ({
  type: ERRORS_SET,
  payload,
});

export const setExecutiveSummaryMessage = payload => ({
  type: EXECUTIVE_SUMMARY_MESSAGE_SET,
  payload,
});

const setIsSavingExecutiveSummary = payload => ({
  type: IS_SAVING_EXECUTIVE_SUMMARY_SET,
  payload,
});

const setIsDeletingExecutiveSummary = payload => ({
  type: IS_DELETING_EXECUTIVE_SUMMARY_SET,
  payload,
});

const setIsEditExecutiveSummaryModal = payload => ({
  type: IS_EDIT_EXECUTIVE_SUMMARY_MODAL_OPEN_SET,
  payload,
});

export const openEditExecutiveSummaryModal = () => setIsEditExecutiveSummaryModal(true);

export const closeEditExecutiveSummaryModal = () => setIsEditExecutiveSummaryModal(false);

export const saveExecutiveSummary = (clientId, summary) => async dispatch => {
  if (summary === null) {
    dispatch(setIsDeletingExecutiveSummary(true));
  } else {
    dispatch(setIsSavingExecutiveSummary(true));
  }

  const data = { clientId };

  if (summary) {
    data.summary = summary;
  }

  try {
    const response = await fetchWithDefaults('/Consumer/Summary/Save', {
      method: 'POST',
      ...httpBodyOptions(data),
    });

    const { success, errors } = await response.json();

    if (success) {
      dispatch(setErrors([]));
      dispatch(setExecutiveSummaryMessage(summary));
      dispatch(closeEditExecutiveSummaryModal());
    } else {
      dispatch(setErrors(errors));
    }
  } catch (err) {
    console.error(err);

    dispatch(setErrors(['There was a problem completing your request. Please try again later.']));
  }

  if (summary === null) {
    dispatch(setIsDeletingExecutiveSummary(false));
  } else {
    dispatch(setIsSavingExecutiveSummary(false));
  }
};
